import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input, Select,} from 'antd';
import { useBnsJiShuWenDangUpdateQuery, useBnsJiShuWenDangUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import GetUserDept from '../../cpn/GetUserDept';
import { techDocType } from '../developPublic';
import MyEditor from '../../cpn/MyEditor';
import { EditOutlined } from '@ant-design/icons';
function TechDocEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bjswd_content:''
    }); 
    const {data,isSuccess} = useBnsJiShuWenDangUpdateQuery({bjswd_id:props.bjswd_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bjswd_name:data.Result.bjswd_name,
                    bjswd_type_id:data.Result.bjswd_type_id,
                    bjswd_dept_id:data.Result.bjswd_dept_id,
                    bjswd_content:data.Result.bjswd_content,
                })
                setInfo(prevState=>({...prevState,
                    bjswd_name:data.Result.bjswd_name,                  
                    bjswd_dept_id:data.Result.bjswd_dept_id,                  
                    bjswd_content:data.Result.bjswd_content,                  
                    bjswd_dept_name:data.Result.bjswd_dept_name,   
                    bjswd_type_id:data.Result.bjswd_type_id,      
                    bjswd_type_name:data.Result.bjswd_type_name,         
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsJiShuWenDangUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined />修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改技术文档'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bjswd_content" : info.bjswd_content,
                        "bjswd_dept_id" : info.bjswd_dept_id,
                        "bjswd_dept_name" : info.bjswd_dept_name,
                        "bjswd_e_id" : localStorage.getItem('e_id'),
                        "bjswd_id" : props.bjswd_id,
                        "bjswd_name" : info.bjswd_name,
                        "bjswd_type_id" : info.bjswd_type_id,
                        "bjswd_type_name" : info.bjswd_type_name,
                        "bjswd_uid" : localStorage.getItem('eu_id'),
                        "bjswd_uname" : localStorage.getItem('eu_name'),                  
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <GetUserDept
                        label='部门'
                        required
                        wrapperCol={{span:10}} 
                        getUserDept={(e,f) => {
                            setInfo(prevState=>({...prevState,bjswd_dept_id:e,bjswd_dept_name:f}))
                        }}
                        name='bjswd_dept_id'
                    />
                    <Form.Item
                        label='类型'
                        name='bjswd_type_id'
                        wrapperCol={{span:10}}
                        required                            
                    >
                        <Select
                            options={techDocType}
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bjswd_type_id:e,bjswd_type_name:f.label}))
                            }}
                            showSearch
                            optionFilterProp="label"
                        />
                    </Form.Item>
                    <Form.Item name="bjswd_name" label='标题' wrapperCol={{span:20}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bjswd_name:e.target.value}))}}
                        />
                    </Form.Item> 
                    <Form.Item name="bjswd_content" label='正文' wrapperCol={{span:20}}>
                        <MyEditor
                            onChange={(e) => {setInfo(prevState=>({...prevState,bjswd_content:e}))}}
                            height={800}
                        />
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default TechDocEdit